import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './HomePageCss/TestimonialCarousal.css';

import maleImg from "../../Assets/male.png"

const users = [
    {
        img: maleImg,
        name: "Govinda Rao",
        recedential: "",
        comments:
            "I had a great experience at RB Diagnostic. The staff was professional, courteous, and very helpful throughout the process. The facility was clean and well-maintained, and the procedures were conducted smoothly and on time. The reports were delivered quickly and were easy to understand. Highly recommended for anyone looking for accurate and hassle-free diagnostic services."
    },
    {
        img: "https://img.freepik.com/premium-vector/woman-avatar-profile-round-icon_24640-14042.jpg",
        name: "Deepmala Singh",
        recedential: "",
        comments:
            "RB is the best click I have ever seen in my life. Doctor's behaviours are really very good and polite. They listen your problem very nicely and guide you with proper medicine according to your problems. Except doctors of RB most of the staff's behaviour is very good"
    },
    {
        img: "https://img.freepik.com/premium-vector/woman-avatar-profile-round-icon_24640-14042.jpg",
        name: "Swarnali Saha",
        recedential: "",
        comments:
            "RB Diagnostic  offers excellent service with proper care and efficiency. Wide range of doctors and skilled medical staff help the patients experience a sound and seamless treatment. Special thanks to Ms. Dipanwita for her kind assistance and professional care—truly appreciated!"
    },
    {
        img: "https://img.freepik.com/premium-vector/woman-avatar-profile-round-icon_24640-14042.jpg",
        name: "Nidhi Gupta",
        recedential: "",
        comments:
            `I felt comfortable throughout my visit..the staff were friendly and professional..
Dr DD kothari is well experienced doc who took the time to explain everything clearly..
Over all it was nice experience..I would highly recommend this clinic to others..`
    },
    {
        img: maleImg,
        name: "Prabal Mukherjee",
        recedential: "",
        comments:
            "Good place with very good, experienced and expert doctors..I went for an appointment with Dr.Barun Chakraborty and he was very much informative and always try to answer all the questions in an easy manner.This place has a good seating arrangements..restrooms are clean..staffs are well mannered and well behaved..payments can be done with cash,cards or upi. Everything is neat and tidy.."
    },
    {
        img: maleImg,
        name: "Aritra sikdar",
        recedential: ``,
        comments:
            `RB Diagnostic has always been a renowned and trustworthy place to get medical tests done. There are also plenty of doctors available for OPD.
I have uploaded the list of doctors of whom you can get appointments here at the Lake Town branch
`
    },
    {
        img: "https://img.freepik.com/premium-vector/woman-avatar-profile-round-icon_24640-14042.jpg",
        name: "Sutrishna Debnath",
        recedential: "",
        comments:
            "I had a wonderful experience at RB diagnostic centre. The staff is extremely polite, helpful, and professional. The entire facility is very clean and spacious, with a large waiting area that makes the experience comfortable. All the doctors are highly knowledgeable and caring, making you feel at ease throughout. I truly recommend this place to anyone looking for quality diagnostic services with top-notch hospitality"
    },
    {
        img: maleImg,
        name: "Shrishendu Biswas",
        recedential: "",
        comments:
            `I had a great experience at the Dermatology Unit of RB Diagnostics. They offer a wide range of dermatological procedures—from skin treatments, laser therapies, peels, to minor surgical procedures—everything is done with professionalism and care.

The dermatology team is experienced and patient, and they take the time to explain the treatment plan in detail. The setup is clean, modern, and comfortable, which made me feel at ease right from the beginning.

Special mention to the Swati (receptionist), who was extremely polite and helpful. She ensured smooth coordination and kept the appointment process very easy and quick.

Highly recommended for anyone looking for quality dermatological care in Kolkata!
`
    },
];

const TestimonialCarousel = ({ onSlideChange }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const settings = {
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        infinite: true,
        arrows: true,
        beforeChange: (oldIndex, newIndex) => {
            setCurrentIndex(newIndex);
            if (onSlideChange) {
                onSlideChange(users[newIndex]);
            }
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className="testimonial-container">
            <Slider {...settings}>
                {users.map((user, index) => (
                    <div className="image-card" key={index}>
                        <img src={user.img} alt={`user-${index}`} className="testimonial-img" />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default TestimonialCarousel;
export { users };
